<template>
  <div class="blog-detail-wrapper p-0">
    <b-card>
      <b-spinner v-if="isLoading" class="align-middle mb-2" variant="secondary"></b-spinner>
      <b-row>
          <b-col sm="12">
              <b-form-group>
                  Title <span class="text-danger">*</span>
                  <b-form-input
                    v-model="title"
                    />
              </b-form-group>
          </b-col>
          <b-col sm="6">
            <validation-provider
            name="CFU"
            rules="required"
            >
                <b-form-group>
                    <template #label>
                        Category <span class="text-danger">*</span>
                    </template>
                    <v-select
                    v-model="category"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="cfus"
                    />
                </b-form-group>
            </validation-provider>
          </b-col>
          <b-col sm="6">
              <validation-provider
              name="Division"
              rules="required"
              >
                  <b-form-group>
                      <template #label>
                          Product <span class="text-danger">*</span>
                      </template>
                      <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="product"
                      :options="products"
                      label="PRODUCT"
                      key="KODE"
                      />
                  </b-form-group>
              </validation-provider>
          </b-col>
          <b-col sm="12">
              <b-form-group>
                  Body <span class="text-danger">*</span>
                  <snote v-model="body" ref="snoteSDescription"/>
              </b-form-group>
          </b-col>
          <b-col sm="12">
              File Lampiran
              <div id="attachment" class="dropzone dropzone-area mb-3">
                  <div class="dz-message"><feather-icon size="50" icon="DownloadIcon" /></div>
              </div>
          </b-col>
          <b-col sm="12">
            <b-form-group class="d-flex justify-content-end">
                <b-spinner v-if="isLoading" class="align-middle mr-1" variant="secondary"></b-spinner>
                <b-button
                :disabled="isLoading"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="submit()"
                >
                Submit
                </b-button>
            </b-form-group>
          </b-col>
      </b-row>
    </b-card>
    <!--/ blogs -->
  </div>
</template>

<script>
import { BSpinner, BForm, BFormGroup, BFormInput,BAvatar,BLink,BCardText,BCard, BContainer, BRow, BCol, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import snote from './summernote.vue'

export default {
  components: {
    BSpinner,
    BForm, 
    BFormGroup, 
    BFormInput,
    BAvatar,
    BCardText,
    BCard,
    BLink,
    BContainer,
    BRow,
    BCol,
    BButton,
    vSelect,
    'snote': snote
  },

  data() {
    return {
        isLoading:false,
        category:null,
        cfus:[],
        product:null,
        products:[],
        title:null,
        body:null,
        attachment:[]
    }
  },

  watch: {
    category(newVal,oldVal){
        this.getProduct(newVal.id)
    }
  },

  created(){
    
  },

  mounted() {
    this.initDropzone()
    this.getCategory()
  },

  methods: {
    initDropzone() {
      const options = {
        maxFiles: 5,
        maxFilesize:5,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: "application/pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx",
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }

      const { drawAtachments, deleteTempAttachemts } = this
      this.dzAttachmentsIns = new window.Dropzone('#attachment', {
        ...options,
        url: `${process.env.VUE_APP_API_HOST}/api/discussion/uploadFile`,
        init() {
          this.on('success', (file, res) => drawAtachments(file,res))
          this.on('removedfile', file => deleteTempAttachemts(file))
        },
      })
    },

    drawAtachments(file,res) {
      this.attachment.push(res)
    },

    deleteTempAttachemts(file) {
      const deleteFileTempUrl = '/discussion/deleteFile'

      this.$http
        .post(deleteFileTempUrl, {
          file: file,
        })
        .then(() => {
          this.attachment = []
        })
        .catch(({ data }) => {
          console.log(data)
        })
    },
    validationForm() {
        let errMessage = [];
        if(this.title == '' || this.title == null || this.title == '<br>'){
            errMessage.push('Title')
        }
        if(this.category == '' || this.category == null || this.category == '<br>'){
            errMessage.push('Category')
        }
        if(this.product == '' || this.product == null || this.product == '<br>'){
            errMessage.push('Product')
        }
        if(this.body == '' || this.body == null || this.body == '<br>'){
            errMessage.push('Body')
        }

        if(errMessage.length > 0){
            this.$notif('Please fill these field',`${errMessage.join(', ')} fields is required.`,'danger','InfoIcon',5000)
            return false;
        }

        return true
    },
    submit(){
        let valid = this.validationForm()
        if(valid){
            this.sendData() 
        }
    },
    sendData(){
        this.isLoading = true
        this.$http
        .post('/discussion/store', {
            title: this.title,
            category_id: this.category.id,
            product_id: this.product.KODE,
            body: this.body,
            file: this.attachment
        })
        .then(() => {
            this.$notif('Success', 'Discussion has been successfully submited.', 'success', 'InfoIcon', 7000)
            this.$router.push({ name: 'discussion' })
        })
        .catch(({ data }) => {
            this.$notif('Error', `${data.message}`, 'error', 'InfoIcon', 1000)
        })
        .finally(() => {
            this.isLoading = false
        })
    },
    getYears:function(start,stop){
        return new Array(stop-start).fill(start).map((n,i)=>n+i);
    },
    getCategory() {
        this.isLoading = true
        return this.$http.get(`/product-category`)
        .then(res => {
            this.isLoading = false
            this.cfus = res.data.data.records
        })
    },
    getProduct(id) {
        this.isLoading = true
        this.product = null
        this.products = []
        return this.$http.get(`/discussion/getProductByCat/${id}`)
        .then(res => {
            this.isLoading = false
            this.products = res.data
            return res
        })
        .catch(err => {
            console.error(err)
        })
    }
  },
}
</script>

<style scoped>
.dropzone {
    min-height: 250px;
}
/deep/ .dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
/deep/ .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>